import { Box, Container, InputBase, Theme } from "@mui/material";
import Grid from "@mui/material/Grid";
import makeStyles from "@mui/styles/makeStyles";
import React, { useState } from "react";
import Tile from "../components/Tile";
import { Config } from "../Config";
import { App } from "../services/Types";

const useStyles = makeStyles((theme: Theme) => ({
  search: {
    backgroundColor: theme.palette.common.white,
    border: "1px solid #e3e3e3",
    "& input": { textAlign: "left" },
  },
  main: { padding: "20px 0 50px" },
  wrapper: { position: "relative" },
  alerts: {
    position: "absolute",
    left: "20px",
    top: "30px",
    width: "300px",
  },
}));

function HomePage() {
  const classes = useStyles();
  const [apps, setApps] = useState<App[]>(Config.apps);

  const handleSearch = (event: any) => {
    let value = event.target.value.toLowerCase();
    let result = [];
    result = Config.apps.filter((app: App) => {
      return app.name.toLowerCase().search(value) !== -1;
    });
    setApps(result);
  };

  return (
    <div className={classes.wrapper}>
      <div id="internal_alerts" className={classes.alerts}></div>
      {Config.environment.code === "DEV" && (
        <Box className={classes.search}>
          <InputBase
            placeholder="Search…"
            inputProps={{ "aria-label": "search" }}
            onChange={(event) => handleSearch(event)}
          />
        </Box>
      )}
      <Container maxWidth="lg">
        <Grid
          sx={{ flexGrow: 1 }}
          container
          spacing={4}
          className={classes.main}
        >
          <Grid item xs={12}>
            <Grid container justifyContent="center" spacing={5}>
              {apps.map((app, index) => (
                <Tile key={index} app={app} />
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default HomePage;
